import React from 'react';
import PropTypes from 'prop-types';
import styles from '../Footer.module.scss';

const TwineNetwork = ({ omitHeading = false }) => {
  return (
    <ul className={styles.linkList}>
      {!omitHeading && (
        <li>
          <a href="https://www.twine.net/">Twine network</a>
        </li>
      )}
      <li>
        <a href="/about">About Twine</a>
      </li>
      <li>
        <a href="/ai">Twine AI</a>
      </li>
      <li>
        <a href="/advertise">Advertise</a>
      </li>
      <li>
        <a href="/contact">Support</a>
      </li>
      <li>
        <a href="/signin">Log in</a>
      </li>
      <li>
        <a href="/signup">Sign up</a>
      </li>
    </ul>
  );
};

TwineNetwork.propTypes = {
  omitHeading: PropTypes.bool,
};

export default TwineNetwork;
